import React from 'react';
import { Icon } from '@iconify/react';
import AnimateHeight from 'react-animate-height';
import TrialTagFields from './TrialTagFields';
import TrialTagChips from './TrialTagChips';
import TrialRecordingTimer from './TrialRecordingTimer';
import { TRIAL_SCOPE, summarizeTags } from '../../util/trialTagFields';
import '../../../dist/assets/stylesheets/css/recordPatient.css';

function RecordingPanel(props) {
  const {
    trial,
    disabled,
    startRecord,
    stopRecord,
    removeTrial,
    tagsExpanded,
    onToggleTags,
    onTagChange,
    tagSuggestions,
    tagIdPrefix = 'trial-tag',
  } = props;
  const isStopping = !!(trial.isRecording && trial.isLoading);
  const isBusy = trial.isLoading || trial.isRecording;
  const actionsDisabled = disabled || trial.isLoading;
  const chips = summarizeTags(trial.trialTags, TRIAL_SCOPE);
  const panelId = `${tagIdPrefix}-panel`;

  return (
    <div className="recording-trial">
      <div className={'recording-panel ' + (disabled ? 'disabled' : '')}>
        <div className="recording-panel__info">
          {trial.finishedRecording && <Icon className="check" icon="ei:check" aria-hidden />}
          <span className="recording-panel__labels">
            <span className="recording-panel__meta">
              <span className="recording-panel__label">Patient</span> {trial.patientName}
            </span>
            {trial.calibrationID != null && (
              <span className="recording-panel__meta">
                <span className="recording-panel__label">Calibration ID</span> {trial.calibrationID}
              </span>
            )}
          </span>
          <TrialTagChips items={chips} className="recording-panel__chips" />
        </div>
        <div className="recording-panel__actions">
          <TrialRecordingTimer
            startedAt={trial.recordingStartedAt}
            endedAt={trial.recordingEndedAt}
          />
          <button
            type="button"
            className="recording-panel__toggle"
            aria-expanded={!!tagsExpanded}
            aria-controls={panelId}
            disabled={actionsDisabled}
            onClick={onToggleTags}
          >
            Tags
            <Icon icon="iconamoon:arrow-up-2-light" className={tagsExpanded ? 'open' : undefined} />
          </button>
          {trial.isRecording ? (
            <button
              type="button"
              disabled={actionsDisabled}
              className="recording-btn recording-btn--stop"
              onClick={stopRecord}
            >
              {isStopping ? 'Stopping…' : 'Stop Recording'}
            </button>
          ) : trial.finishedRecording ? null : (
            <button
              type="button"
              disabled={actionsDisabled}
              className="recording-btn recording-btn--start"
              onClick={startRecord}
            >
              {trial.isLoading ? 'Starting…' : 'Start Recording'}
            </button>
          )}
          <button
            type="button"
            disabled={trial.isRecording || trial.isDeleting || disabled}
            className="delete-btn"
            onClick={removeTrial}
          >
            {trial.isDeleting ? 'Deleting…' : 'Delete'}
          </button>
        </div>
      </div>
      <AnimateHeight
        id={panelId}
        className="record-dropdown-animate-height"
        duration={420}
        height={tagsExpanded ? 'auto' : 0}
        easing="cubic-bezier(0.33, 1, 0.68, 1)"
        animateOpacity
      >
        <div className="recording-trial__tags">
          <TrialTagFields
            scope={TRIAL_SCOPE}
            values={trial.trialTags}
            onChange={onTagChange}
            idPrefix={tagIdPrefix}
            suggestions={tagSuggestions}
            disabled={actionsDisabled}
          />
        </div>
      </AnimateHeight>
    </div>
  );
}

export default RecordingPanel;
